// URS-F416b: helper defensivo para renderizar errores de axios.
//
// FastAPI (y otros backends) pueden devolver `detail` como STRING o como
// OBJETO estructurado (por ejemplo el `duplicate_visit_appointment` que
// devuelve `{code, message, appointment}`). Pasar un objeto directamente
// a `toast.error(...)` de sonner hace crash a React con:
//   "Objects are not valid as a React child (found: object with keys ...)."
//
// Este helper garantiza que SIEMPRE se devuelve una string legible.

/**
 * Extrae un mensaje legible de un error de axios.
 * @param {*} err Cualquier error (idealmente el de axios).
 * @param {string} [fallback] Mensaje por defecto si no hay nada util.
 * @returns {string}
 */
export function errText(err, fallback = 'Error') {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || fallback;
  if (typeof d === 'string') return d;
  if (typeof d === 'object') return d.message || d.code || fallback;
  return String(d);
}

export default errText;
